import { ChangeEvent, useState } from "react";
import { Moment } from "moment";
import {
  BUTTON_COLORS,
  BUTTON_SIZES,
  BUTTON_VARIANTS,
  DATE_TIME_FORMATS,
} from "@miplatform/constants";
import { getDate } from "@miplatform/utils";
import { Box, useTheme } from "@mui/material";
import { MiDatePicker } from "../MiDatePicker/MiDatePicker";
import { MiInputTextbox } from "../MiInputTextBox/MiInputTextBox";
import { MiModal } from "../MiModal/MiModal";

export const ClearScheduleModal = ({
  isOpen,
  onClose,
  onConfirm,
  date,
  name,
}: Readonly<{
  isOpen: boolean;
  onClose: () => void;
  onConfirm: (reason: string) => void;
  date: Moment;
  name?: string;
}>) => {
  const theme = useTheme();
  const [reason, setReason] = useState("");

  const onReasonChange = (event: ChangeEvent<HTMLInputElement>) => {
    setReason(event.target.value);
  };

  const clearReason = () => {
    setReason("");
  };

  const handleConfirm = () => {
    onConfirm(reason);
    clearReason();
  };

  const handleClose = () => {
    onClose();
    clearReason();
  };

  return (
    <MiModal
      title={`Clear Schedule ${date.isSame(getDate(), "day") ? "(Today)" : ""}`}
      description={`Remove all assignments for ${name} on ${date.format(
        DATE_TIME_FORMATS.FORMAT_MM_DD_YYYY
      )}.\nCleared Orders return to the bucket with priority styling.`}
      open={isOpen}
      closeModal={handleClose}
      actions={[
        {
          name: "Cancel",
          variant: BUTTON_VARIANTS.TEXT,
          size: BUTTON_SIZES.MEDIUM,
          color: BUTTON_COLORS.BLACK,
          onClick: handleClose,
        },
        {
          name: "Submit",
          variant: BUTTON_VARIANTS.CONTAINED,
          disabled: !reason?.trim(),
          size: BUTTON_SIZES.MEDIUM,
          onClick: () => {
            handleConfirm();
          },
        },
      ]}
    >
      <Box
        gap={2}
        display="flex"
        flexDirection="column"
        padding={theme.spacing(1, 0)}
      >
        <MiDatePicker label="Date" value={date} disabled />
        <MiInputTextbox label="Service Technician" value={name} disabled />
        <MiInputTextbox
          label="Reason"
          name="reason"
          required
          value={reason}
          onChange={onReasonChange}
        />
      </Box>
    </MiModal>
  );
};
